
























































































import { defineComponent, computed, ref, watch } from '@vue/composition-api';
import useMainLayout from '@/composables/useMainLayout';
import MainLayoutInfo, { LayoutType, LayoutBreakPoint, primaryRelatedWidth } from '@/data/layout/MainLayoutInfo';

export default defineComponent({
  name: 'mainLayout',
  props: {
    onlyHeader: {
      type: Boolean,
      default: false
    },
    hidePrimaryMain: {
      type: Boolean,
      default: false
    },
    primaryRelatedIsLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    'primary-related-changed': (/*htmlElem: Ref<HTMLDivElement|null>*/) => true
  },
  setup(props) {
    const { layoutType } = useMainLayout();
    const primaryMain = ref<HTMLElement|null>(null);
    const primaryRelated = ref<HTMLElement|null>(null);
    const halfOfmarginH = computed(() => {
      return MainLayoutInfo.getGlobalMarginH(layoutType.value) / 2.0 + 'px';
    });
    const showPrimaryRelated = computed(() => {
      return layoutType.value >= LayoutType.LARGE;
    });

    const pageWidth = computed(() => {
      switch(layoutType.value) {
        case LayoutType.SMALL: return '100%';
        case LayoutType.MEDIUM: return LayoutBreakPoint.SMALL + 'px';
        case LayoutType.LARGE: return LayoutBreakPoint.MEDIUM + 'px';
        case LayoutType.XLARGE: return LayoutBreakPoint.LARGE + 'px';
      }
    });

    const primaryMainWidth = computed(() => {
      switch(layoutType.value) {
        case LayoutType.SMALL: 
        case LayoutType.MEDIUM:
          return '100%';
        case LayoutType.LARGE:
        case LayoutType.XLARGE:
          return `calc(100% - ${primaryRelatedWidth}px)`;
      }
    });

    const primaryRelatedWidthC = computed(() => {

      switch(layoutType.value) {
        case LayoutType.SMALL: 
        case LayoutType.MEDIUM:
          return '0px';
        case LayoutType.LARGE:
        case LayoutType.XLARGE:
          return `${primaryRelatedWidth}px`;
      }      
    });

    watch(
      () => props.primaryRelatedIsLoading,
      (newVal) => {
        if(primaryRelated.value && newVal === true) {
          primaryRelated.value.scrollTop = 0;
        }
      }
    );

    return {
      halfOfmarginH,
      showPrimaryRelated,
      primaryMain,
      primaryRelated,
      pageWidth,
      primaryMainWidth,
      primaryRelatedWidthC
    }
  }
});

